import type { ReactNode } from 'react';

import styles from './FallbackScreen.module.css';

interface FallbackScreenProps {
  /** Главная строка — то, что человек должен понять. Всегда есть. */
  title: string;
  /** Поясняющая строка под ней. Необязательна: иногда хватает одной фразы. */
  desc?: string;
}

/**
 * Презентационная заглушка на весь экран: центрированная карточка с текстом.
 *
 * Общая для `ErrorBoundary` (непойманная ошибка рендера) и
 * `NotInTelegramScreen` (SDK не поднялся — приложение открыли вне Telegram).
 * Вынесена, чтобы вёрстка и цветовые фолбэки жили в одном месте: оба экрана
 * рендерятся вне <AppRoot> и вне темы Telegram, и разъехавшиеся копии CSS
 * означали бы, что один из них однажды окажется белым (см. FallbackScreen.module.css).
 *
 * Никакой логики и никаких зависимостей от контекста — это последняя линия
 * обороны, она не имеет права сама упасть.
 */
export function FallbackScreen({ title, desc }: FallbackScreenProps): ReactNode {
  return (
    <div className={styles.root}>
      <div className={styles.card}>
        <p className={styles.title}>{title}</p>
        {desc === undefined ? null : <p className={styles.desc}>{desc}</p>}
      </div>
    </div>
  );
}
